import {http} from "../utils/http";
import {Response} from '../types/resp';
export const transfer = {
	transferWallet: async () => {
		return http.post<Response<any>>('/transfer-wallet', {})
	},

	transferAutoWithdraw: async (payload: any) => {
		return http.post<Response<any>>('/transfer-auto-withdraw', payload)
	},

	transferSumTurn: async (payload: any) => {
		return http.post<Response<any>>('/transfer-sum-turn', payload)
	},
}
